import React, { useState, useEffect } from 'react';
import globals from '../../globals.json';
import FameMeter from '../partials/FameMeter';

const DriversReport = props => {
    // as animationFrame increments, new elements are animated into the scene
    const [animationFrame, setAnimationFrame] = useState(0);
    const tripScore = props.scoring.getScore(props.scoring.tempTrip);
    // body3 is 100% correct, body2 is some correct, body1 is none correct
    const bodyText = props.data.feedback[
        tripScore === 100 
            ? 'perfect'
            : tripScore > 70
                ? 'good'
                : 'poor'
    ]

    useEffect(() => {
        props.scoring.saveScore(props.data.tripScoreId);
        props.audioController.playAudioByName(tripScore === 100 ? 'tripConcl_1' : 'tripConcl_2');
        setTimeout(() => {
            setAnimationFrame(1);
        }, 1000)
        setTimeout(() => {
            setAnimationFrame(2);
        }, 1500)
        setTimeout(() => {
            setAnimationFrame(3);
        }, 3000)
        return () => {
            props.audioController.removeAllAudio();
        }
    }, [])

    const handleContinue = () => {
        props.scoring.tearDownTrip();
        props.onComplete();
    }
    console.log("props.scoring.getScore(props.data.tripScoreId)" , props.scoring.getScore(props.data.tripScoreId))
   
    console.log("getTotalScore" , props.scoring.getTotalScore());
    return (       
        <div className={`DriversReport`}>
            <div className={`top-right-orange ${animationFrame > 0 ? 'slide-left' : ''}`} />
            <div className={`bottom-left-orange ${animationFrame > 1 ? 'slide-right' : ''}`} />
            <div className={`left-content`}>
                <div className={`header`} dangerouslySetInnerHTML={{__html: props.data.header}} />
                <div className={`yellow-box`} />
                <div className={`body-text`} dangerouslySetInnerHTML={{__html: bodyText}} />                
                <FameMeter totalScore={props.scoring.getTotalTripScore(props.data.tripScoreId)} data={props.data.fameMeter}/>
            </div>
            <div className={`checklist`}>
                <div className={`checklist-header`}>
                    <h3>{props.data.checklistHeader1}</h3>
                    <h3>{`${props.data.checklistHeader2}${props.scoring.getScore(props.data.tripScoreId)}.`}</h3>
                </div>
                <div className={`list-container`}>{                   
                    props.scoring.getChecklistArray(props.data.tripScoreId).map((e,i) => {                       
                        return <div className={`list-item list-item-${i} ${e ? 'complete' : 'incomplete'}`}>
                            <div className={'checkmark'} />
                            <div className={'check-box'} />
                            <div className={`text`} dangerouslySetInnerHTML={{__html:props.data.listItems[i]}} />
                        </div> 
                    })
                }</div>
            </div>
            <div className={`global-button continue-button`} onClick={handleContinue}>{globals.continueButtonText}</div>
        </div>
    )
}

export default DriversReport